export default __webpack_public_path__ + "static/main-logo-b6b02e8d60bfc6aaf6e2808319e4b9b1.svg";